<template>
  <div class="main-content">
    <div class="layout-all">
      <div class="presentation-webcast-content">
        <div class="title-content">
          <div class="d-flex justify-center">
            {{ FiltersLanguage(item_presentation_webcast, "title") }}
            <div>
              <v-img
                class="title-icon"
                :src="require(`@/${item_presentation_webcast.img_dot}`)"
              ></v-img>
            </div>
          </div>
        </div>
        <hr class="hr-border" />
        <!-- content file download -->
        <div>
          <v-img
            :src="
              require(`@/${FiltersLanguage(
                item_presentation_webcast,
                'img_banner'
              )}`)
            "
          ></v-img>
        </div>
        <div class="layout-download-all">
          <div class="layout-selector-all">
            <div>
              <div class="title-select">
                {{ FiltersLanguage(item_presentation_webcast, "title_select") }}
              </div>
              <div class="select-style">
                <v-select
                  v-model="yearSelectPresentationAndWebcast"
                  :items="itemsYearSelectPresentationAndWebcast"
                  item-value="year_eng"
                  outlined
                  item-color="green"
                  background-color="#fff"
                  color="loadingAll"
                  class="custom-select"
                  @change="initTablePresentationAndWebcast()"
                >
                  <template v-slot:selection="{ item }">
                    <span class="label-select">
                      {{ FiltersLanguage(item, "year") }}</span
                    >
                  </template>
                  <template v-slot:item="{ item }">
                    <span class="items-select">{{
                      FiltersLanguage(item, "year")
                    }}</span>
                  </template>
                </v-select>
              </div>
            </div>
          </div>
          <div class="layout-file-download-all">
            <div class="box-file-download-all">
              <div
                class="box-file-download"
                v-for="(item_file, i) in itemTablePresentationAndWebcast"
                :key="i"
              >
                <div class="text-box mr-auto">
                  <div class="title-download">
                    {{ FiltersLanguage(item_file, "title") }}
                  </div>
                  <div class="date-download">
                    {{ returnFormateDate(item_file.create_date, language) }}
                  </div>
                </div>
                <div class="layout-icon">
                  <div class="icon-play-box">
                    <a
                      :href="FiltersLanguage(item_file, 'video')"
                      target="_blank"
                      v-if="
                        FiltersLanguage(item_file, 'video') !== '' &&
                        FiltersLanguage(item_file, 'video') !== undefined
                      "
                    >
                      <v-icon class="icon-play">
                        mdi-play-circle-outline
                      </v-icon>
                    </a>
                    <v-icon v-else class="icon-play-none">
                      mdi-play-circle-outline
                    </v-icon>
                  </div>
                  <div class="icon-download-box">
                    <a
                      :href="`${env}/api/v1/file/${FiltersLanguage(
                        item_file,
                        'file'
                      )}`"
                      target="_blank"
                      v-if="
                        FiltersLanguage(item_file, 'file') !== '' &&
                        FiltersLanguage(item_file, 'file') !== undefined
                      "
                    >
                      <v-icon class="icon-download"> mdi-download </v-icon>
                    </a>
                    <v-icon v-else class="icon-download-none">
                      mdi-download
                    </v-icon>
                  </div>
                </div>
                <div style="width: 100%">
                  <hr
                    :style="
                      i + 1 === itemTablePresentationAndWebcast.length
                        ? 'display:none'
                        : 'margin-top:15px; margin-bottom:15px;'
                    "
                    class="hr-border-box-download"
                  />
                </div>
              </div>
              <div
                v-if="itemTablePresentationAndWebcast.length === 0"
                class="text-center blue-grey--text"
              >
                No Data
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      yearSelectPresentationAndWebcast: '',
      itemsYearSelectPresentationAndWebcast: [],
      loadingTablePresentationAndWebcast: false,
      paginationTablePresentationAndWebcast: {
        total: 0,
        page: 1,
        row: 9999
      },
      itemTablePresentationAndWebcast: []
    }
  },
  computed: {
    ...mapGetters([
      'item_presentation_webcast',
      'item_file_presentation_webcast'
    ])
  },
  created () {
    this.env = process.env.VUE_APP_API
    const yearNow = this.$moment().format('YYYY')
    this.yearSelectPresentationAndWebcast = yearNow
    this.initItemsYearsSelectPresentationAndWebcast()
    this.init()
  },
  mounted () {},
  methods: {
    initItemsYearsSelectPresentationAndWebcast () {
      const years = parseInt(this.$moment().format('YYYY'))
      const itemsYears = []
      itemsYears.push({ year_th: 'ทั้งหมด', year_eng: 'all' })
      for (let index = years; index >= 2016; index--) {
        // itemsYears.push({
        //   text: JSON.stringify(index + 543),
        //   val: JSON.stringify(index)
        // })
        itemsYears.push({
          year_th: JSON.stringify(index + 543),
          year_eng: JSON.stringify(index)
        })
      }
      this.itemsYearSelectPresentationAndWebcast = itemsYears
    },
    async init () {
      this.initTablePresentationAndWebcast()
    },
    async initTablePresentationAndWebcast () {
      this.loadingTablePresentationAndWebcast = true
      const payload = {
        page: this.paginationTablePresentationAndWebcast.page,
        row: this.paginationTablePresentationAndWebcast.row,
        keyword: `Presentation and Webcast ${
          this.yearSelectPresentationAndWebcast !== 'all'
            ? parseInt(this.yearSelectPresentationAndWebcast) + 543
            : ''
        }`
      }
      this.itemTablePresentationAndWebcast = []
      const res = await this.getList(payload)
      this.loadingTablePresentationAndWebcast = false
      if (res.status) {
        if (res.data.data.length !== 0) {
          if (this.yearSelectPresentationAndWebcast === 'all') {
            for (let index = 0; index < res.data.data.length; index++) {
              this.itemTablePresentationAndWebcast =
                this.itemTablePresentationAndWebcast.concat(
                  res.data.data[index].items
                )
            }
          } else {
            this.itemTablePresentationAndWebcast = res.data.data[0].items
          }
        } else {
          this.itemTablePresentationAndWebcast = []
        }
        this.paginationTablePresentationAndWebcast.total =
          res.data.pagination.total
        this.paginationTablePresentationAndWebcast.page =
          res.data.pagination.page
      } else {
        this.antmessage.error(res.message)
      }
    }
  }
}
</script>

<style lang="css" scoped>
>>> .custom-select .v-input__control .v-input__slot {
  border-radius: 10px !important;
}
.layout-all {
  margin-right: 20px;
  margin-left: 20px;
}
.presentation-webcast-content {
  width: 100%;
}
.title-content {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  font-weight: 700;
  padding-top: 4rem;
  text-align: center;
}
.title-icon {
  width: 16px;
  height: 16px;
  margin-left: 5px;
}
.hr-border {
  color: var(--v-linerPrimary-base) !important;
  margin-top: 40px;
  margin-bottom: 40px;
}
/* content file download */
.layout-download-all {
  padding-top: 40px;
  padding-bottom: 40px;
  display: flex;
  width: 100%;
}
.layout-selector-all {
  width: 30%;
  display: flex;
  justify-content: center;
  padding: 40px;
}
.select-style {
  width: 80%;
  display: flex;
}
.title-select {
  color: var(--v-textTitleSelect-base);
  font-size: 23px;
}
.layout-file-download-all {
  width: 70%;
  border-left: 1px solid #d0d0d0;
  padding-left: 30px;
}
.box-file-download-all {
  background-color: var(--v-bgBoxDownload-base);
  border-radius: 20px;
  padding-left: 50px;
  padding-right: 50px;
  padding-top: 30px;
  padding-bottom: 30px;
}
.box-file-download {
  display: flex;
  flex-wrap: wrap;
  padding-top: 10px;
  align-items: center;
  padding-bottom: 10px;
}
.title-download {
  font-size: 23px;
  font-weight: 500;
}
.date-download {
  color: var(--v-dateDownload-base) !important;
  font-size: 14px;
  font-weight: 500;
}
.text-box {
  padding-right: 5px;
  /* width: 85%; */
}
.layout-icon {
  display: flex;
}
.icon-play-box {
  padding-right: 20px;
  /* width: 15%; */
}
/* .icon-download-box {
  width: 15%;
} */
.icon-play {
  display: flex;
  justify-items: center;
  font-size: 40px;
  color: var(--v-mainIconDownloadInetW2-base) !important;
}
.icon-play:hover {
  background: var(
    --bright-inet,
    linear-gradient(
      136deg,
      rgba(153, 235, 127, 0.8) 0%,
      rgba(65, 232, 204, 0.8) 100%
    )
  );
  -webkit-background-clip: text;
  -moz-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.icon-play-none {
  display: flex;
  justify-items: center;
  font-size: 40px;
  color: grey;
}
.icon-download {
  display: flex;
  justify-items: center;
  font-size: 40px;
  color: var(--v-mainIconDownloadInetW2-base) !important;
}
.icon-download:hover {
  background: var(
    --bright-inet,
    linear-gradient(
      136deg,
      rgba(153, 235, 127, 0.8) 0%,
      rgba(65, 232, 204, 0.8) 100%
    )
  );
  -webkit-background-clip: text;
  -moz-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.icon-download-none {
  display: flex;
  justify-items: center;
  font-size: 40px;
  color: grey;
}
.hr-border-box-download {
  color: var(--v-linerContent-base) !important;
}

@media screen and (max-width: 1200px) {
  .select-style {
    width: 80%;
  }
}
@media screen and (max-width: 984px) {
  .select-style {
    width: 100%;
  }
  .hr-border {
    color: var(--v-linerPrimary-base) !important;
    margin-top: 20px;
    margin-bottom: 30px;
  }
}
@media screen and (max-width: 960px) {
  .layout-download-all {
    flex-wrap: wrap;
  }
  .layout-selector-all {
    width: 100%;
    padding: 10px;
  }
  .layout-file-download-all {
    width: 100%;
    border-left: 0px;
    padding-left: 0px;
  }
}
@media screen and (max-width: 688px) {
  .select-style {
    width: 90%;
  }
}
</style>
